import * as React from "react";
import { Admin, Resource, fetchUtils, Login } from "react-admin";
import jsonServerProvider from "ra-data-json-server";
import { UserList, UserCreate, UserEdit, UserSSPList } from "./users";
import UserIcon from "@material-ui/icons/Group";
import polyglotI18nProvider from "ra-i18n-polyglot";
import italianMessages from "ra-language-italian";
import authProvider from "./authProvider";
import { createMuiTheme } from "@material-ui/core";
import { stringify } from "query-string";
import CustomLayout from "./CustomLayout";

//const servicesHost = "http://localhost:8080";
const servicesHost = "https://elysium.ink/api/v1";

export const httpClient = (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: "application/json" });
  }
  const token = localStorage.getItem("auth");
  options.headers.set("Authorization", `Bearer ${token}`);
  return fetchUtils.fetchJson(url, options);
};

const i18nProvider = polyglotI18nProvider(() => italianMessages, "it");
const dataProvider = jsonServerProvider(servicesHost, httpClient);

const myDataProvider = {
  ...dataProvider,
  getList: (resource, params) => {
    let ssp = false;
    if (resource === "ssp") {
      resource = "gse";
      ssp = true;
    }
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const query = {
      ssp: ssp,
      sort: JSON.stringify([field, order]),
      page: page,
      perPage: perPage,
      filter: JSON.stringify(params.filter),
    };
    const url = `${servicesHost}/${resource}?${stringify(query)}`;

    return httpClient(url).then(({ headers, json }) => ({
      data: json.content,
      //data: json.map(record => ({"id": record.userID, ...record})),
      total: json.totalElements, //temporary hardcoded to avoid headers error.
      //total: parseInt(headers.get('content-range').split('/').pop(), 10),
    }));
  },
  create: (resource, params) => {
    if (resource !== "gse" || !params.data.files) {
      // fallback to the default implementation
      return dataProvider.create(`${resource}/utente`, params);
    }

    let formData = new FormData();

    formData.append("paramOne", params.data.paramOne);
    formData.append("paramTwo", params.data.paramTwo);
    formData.append("file", params.data.files.rawFile);

    return httpClient(`${servicesHost}/${resource}`, {
      method: "POST",
      body: formData,
    }).then(({ json }) => ({
      data: { ...params.data, id: json.id },
    }));
  },
};

const MyLoginPage = () => <Login backgroundImage="/background.jpg" />;

const theme = createMuiTheme({
  palette: {
    // Your theme goes here
    // Write the following code to have an orange app bar. We'll explain it later in this article.
    secondary: {
      main: "#146b37", //"#093579",  Not far from orange ##4e6e5b
    },
  },
});

const initialState = {
  admin: { ui: { sidebarOpen: false, viewVersion: 0 } },
};

const App = () => (
  <Admin
    dataProvider={myDataProvider}
    layout={CustomLayout}
    i18nProvider={i18nProvider}
    authProvider={authProvider}
    loginPage={MyLoginPage}
    initialState={initialState}
    theme={theme}
    disableTelemetry
  >
    <Resource
      name="gse"
      options={{ label: "Utenti" }}
      list={UserList}
      edit={UserEdit}
      create={UserCreate}
      icon={UserIcon}
    />

    <Resource
      name="ssp"
      options={{ label: "Utenti solo SSP" }}
      list={UserSSPList}
      edit={UserEdit}
      create={UserCreate}
      icon={UserIcon}
    />
  </Admin>
);

export default App;
